exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-wrapper {\n  color: #2998E3;\n  text-align: center;\n  padding: 50px;\n}\n\n.loading-text {\n  position: relative;\n  bottom: 6px;\n  left: 15px;\n}\n\n", ""]);

// exports
